import React, { Component, Fragment } from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';

class BulkImportIframe extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const queryParams = encodeURIComponent(`${window.location.search}`);
    return (
      <Fragment>
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `.react-page { height: 100% }`,
          }}
        />
        <iframe
          title="inventory import"
          src={`/webapps_redirect.php?app=retail-bulk-import&next=/item-import${queryParams}`}
          style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        />
      </Fragment>
    );
  }
}

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(BulkImportIframe))
);
